import type { CommonDomainType as MapBuildingDomainType } from 'common/types'
import { isDomainType } from 'common/types'

export type SelectItem<KeyType = string> = { label: string; key: KeyType }

export type SurveyType = 'Survey2D' | 'Survey3D'

export const isMapBuildingDomainType = (toTest: unknown): toTest is MapBuildingDomainType =>
  isDomainType(toTest) && toTest !== 'ANY'
